"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_4g__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "0afd982d-a993-46ce-ad7b-dac129498211",
    "data-name": "4g-hi",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 191.5"
  }, props), /*#__PURE__*/React.createElement("title", null, "4g-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "e941ce9f-48e7-4608-b2df-72c723211c4a",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e60fad51-1968-4d77-84dc-c574d72f2dcd",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "745e721c-7511-4e66-a73e-73115b7f2941",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "278792b7-1fe8-4915-96e9-a786dca406a3",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d2331c0c-6f3a-4d0b-a745-c62569426954",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1bc2019a-666b-4910-93eb-482cf74b23aa",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bb0b36de-884e-458c-bf01-c882a574f702",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "df636d31-f78b-4a68-9b67-f88145dbf846",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8083aeab-bf78-4acc-9439-abb8db080b91",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2172106c-8055-4046-b7ba-09061edd3679",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6481d6d5-2581-42de-8003-776fc8fdee1b",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6db9ec31-76d4-4a59-8349-915cab38b500",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "901154c7-aa58-4013-ba4b-438573593db0",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2b1d42f3-4624-434d-8711-8fabe9ac6098",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "24246e61-924e-4fa7-9421-e4f4c8815b38",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a6e94e63-c4d8-498b-872f-97c044704f0f",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aa24609f-dfc6-481e-b9f2-03b1559142b7",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "30d291e6-7e93-42f7-837a-1ce0e08aad8e",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "743e59bf-a0e8-4602-8042-c666dccf34a9",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05e05861-7457-48db-9f70-f275dc34f58c",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "df18f1f5-7cb5-43c3-b3dc-ff386967463f",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9deb61ac-a299-4e91-8034-95b412da7e96",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9c995941-50aa-4230-89cc-01321170021c",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0076b7bb-3410-4cd9-ab4f-a9a39a75a6a7",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f81ca4c0-cec0-4170-ae32-b90a810073d3",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6bc9eb14-222b-4c1e-a7ef-39442fca29e3",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ed9ed9dc-48b6-49fc-8fe6-478f313c6a1e",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 80,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174.25a80,80,0,0,1-80-79c0,.33,0,.66,0,1a80,80,0,0,0,160,0c0-.34,0-.67,0-1A80,80,0,0,1,96,174.25Z",
    transform: "translate(0 -0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 191.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.32,126.5V114H42.73v-9.5l28.7-42h9.89V103h6.24v11H81.32V126.5ZM55.79,103H69.32V82.44Z",
    transform: "translate(0 -0.25)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.85,127.84a29.21,29.21,0,0,1-11.47-2.21,24.38,24.38,0,0,1-9-6.48,30.14,30.14,0,0,1-5.81-10.42,43.9,43.9,0,0,1-2.06-14A45.12,45.12,0,0,1,97.74,79.8a30.7,30.7,0,0,1,6-10.46,23.69,23.69,0,0,1,8.59-6.19,26.36,26.36,0,0,1,10.22-2q8.26,0,13.54,3.12a21.05,21.05,0,0,1,8,8L135.56,80a15.89,15.89,0,0,0-3.07-3.89A13.66,13.66,0,0,0,128,73.46a15.23,15.23,0,0,0-5.38-1,11.87,11.87,0,0,0-8,3.07,17,17,0,0,0-5.09,8.3A38.47,38.47,0,0,0,108,94.72a29.21,29.21,0,0,0,2.59,12.72q2.59,5.42,6.43,7.2a17.74,17.74,0,0,0,7.49,1.78,35.62,35.62,0,0,0,6.19-.43,16.91,16.91,0,0,0,2.74-.62V103.84h-10v-11H145v30.82a27.76,27.76,0,0,1-7.87,2.88A56.34,56.34,0,0,1,123.85,127.84Z",
    transform: "translate(0 -0.25)",
    fill: "#e60000"
  })))))))))))))))))))))))))))));
}

var _default = ic_4g__dark;
exports.default = _default;